import {FAQSection} from "../../organisms/widget--faqs";

export function ParagraphFaqs ({paragraph, ...props}) {
  if (!paragraph?.faqs?.length) return <></>

  return (
    <FAQSection faqs={paragraph.faqs}/>
  )
}